import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import styles from './Layout.module.css';

// 不显示导航栏的路由前缀（专注学习的页面）
const NO_NAV_PREFIXES = ['/wordstudy', '/learn/'];

const Layout = ({ children }) => {
  const location = useLocation();
  console.log('[Layout] render, path:', location.pathname, 'search:', location.search);
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const shouldShowNavigation = useMemo(() => {
    const path = location.pathname;
    
    // 专注学习页面不显示导航栏（WordStudy, SentenceStudy, NoteStudy）
    for (const prefix of NO_NAV_PREFIXES) {
      if (path.startsWith(prefix)) {
        return false;
      }
    }
    
    // 其他所有页面都显示导航栏
    return true;
  }, [location.pathname]);
  
  return (
    <div className={styles.layout}>
      <main className={`${styles.layoutMain} ${shouldShowNavigation ? styles.withNavigation : styles.withoutNavigation}`}>
        <div className={styles.container}>
          {children}
        </div>
      </main>
      
      {shouldShowNavigation && <Navigation />}
    </div>
  );
};

export default Layout;
